import * as React from "react";
import { Burger, createStyles, Group, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { _mobileWidth } from "../constants";
import { ReactNode } from "react";

const useStyles = createStyles((_theme, _params,) => ({
	title: {
		fontSize: "1.25rem",
		lineHeight: "1.25rem",
		fontWeight: 400,
	},
}));

interface Props {
	title: string;
	sidebarHidden: boolean;
	toggleSidebarHidden: () => void;
	makeWrapper: (
		url: string | undefined,
		child: ReactNode
	) => ReactNode | JSX.Element;
}

export default function _Header({
	title,
	sidebarHidden,
	toggleSidebarHidden,
	makeWrapper,
}: Props) {
	const mobile = useMediaQuery(`(max-width: ${_mobileWidth})`);

	const { classes } = useStyles();

	return (
		<Group
			style={{
				justifyContent: "space-between",
				height: "100%",
				alignItems: "center",
			}}
			position="apart"
		>
			<Group style={{ alignItems: "center", height: "100%" }}>
				{mobile ? (
					<Burger
						opened={!sidebarHidden}
						onClick={() => toggleSidebarHidden()}
						size="sm"
						mr="xs"
					/>
				) : undefined}
				<img
					height="1.25rem"
					src="https://static.vseth.ethz.ch/assets/vseth-0000-vseth/signet.svg"
				/>
				<div className={classes.title}>
					{makeWrapper("/", <Text size="lg">{title}</Text>)}
				</div>
			</Group>
		</Group>
	);
}
